import { render, staticRenderFns } from "./IconWithDetail.vue?vue&type=template&id=c399951e&scoped=true&"
import script from "./IconWithDetail.vue?vue&type=script&lang=js&"
export * from "./IconWithDetail.vue?vue&type=script&lang=js&"
import style0 from "./IconWithDetail.vue?vue&type=style&index=0&id=c399951e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c399951e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
